import { render, staticRenderFns } from "./RequestsComponent.vue?vue&type=template&id=25d6efe3"
import script from "./RequestsComponent.vue?vue&type=script&lang=js"
export * from "./RequestsComponent.vue?vue&type=script&lang=js"
import style0 from "./RequestsComponent.vue?vue&type=style&index=0&id=25d6efe3&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports